import { render } from "./ApproversOverview.vue?vue&type=template&id=554ea552&scoped=true"
import script from "./ApproversOverview.vue?vue&type=script&lang=js"
export * from "./ApproversOverview.vue?vue&type=script&lang=js"

import "./ApproversOverview.vue?vue&type=style&index=0&id=554ea552&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554ea552"]])

export default __exports__